module.exports = __webpack_public_path__ + "static/media/android.8eaf61d9.png";